import Modal from "react-modal";
import Input from "../../../components/Input/Input";
import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import Select from "../../../components/Select/Select";
import "./Convidar.css";
import { useAuth } from "../../../contexts/auth";
import { useUserStore } from "../../../contexts/userStore";
import { LuUserPlus } from "react-icons/lu";
import MultiSelect from "../../../components/MultiSelect/MultiSelect";
import RoleService from "../../../services/RolesService";
import UserService from "../../../services/UserService";
import Loader from "../../../components/Loader/Loader";
import { LevelSelector } from "../../../components/LevelSelector/LevelSelector";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--containerBackgroundColor)",
	},
};

function Convidar(props) {
	const { user } = useAuth();
	const { selectedCondominio, condominiums } = useUserStore();
	const [modalIsOpen, setModalIsOpen] = useState(props.modalIsOpen);
	const [email, setEmail] = useState('');
	const [level, setLevel] = useState(null);
	const [roles, setRoles] = useState([]);
	const [selectedRoles, setSelectedRoles] = useState([]);
	const [showLoader, setShowLoader] = useState(false);

	useEffect(() => {
		async function getRoles() {
			const response = await RoleService.listRoles();
			setRoles(response.data);
		}
		getRoles();
	}, []);

	useEffect(() => {
		setModalIsOpen(props.modalIsOpen);
	}, [props.modalIsOpen]);

	function handleCancel() {
		props.handleCancel(false);
	}

	function buildPayload() {
		const payload = {
			email,
			// level: {
			unitId: level?.unitId,
			hierarchy: level?.childrenAuthorized || false,
			// },
			roleIds: selectedRoles,
			organizationId: condominiums.find(condo => level?.unitId === condo.id)?.organizationId || user.userData.selectedOrganizationId,
		};
		return payload;
	}

	async function sendInvite() {
		setShowLoader(true);
		await UserService.invite(buildPayload());
		setShowLoader(false);
		handleCancel();
	}

	return (
		<>
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={handleCancel}
					style={customStyles}
					contentLabel="Modal"
					ariaHideApp={false}
				>
					<div className="modal-content-container modal-invite">
						<h1 className="modal-text">
							<LuUserPlus />
							Enviar um convite de participação para esta organização
						</h1>
						<React.Fragment>
							<p className="delete-button-modal-text"></p>
							<div className="form-wrapper">
								<Input
									labelText="Email"
									name="email"
									id="email"
									placeholder="Digite o email"
									value={email ?? ''}
									type="email"
									onChange={({ target }) => setEmail(target.value)}
									required={true}
								/>
								<LevelSelector
									levels={level ? [level] : []}
									onChange={(levels) => setLevel(levels[0] || null)}
									type="cadastro"
									title={"Nível de acesso"}
									description={"Selecione o nível de acesso"}
									singleLevel={true}
									showRoot={false}
								/>
								<MultiSelect
									values={selectedRoles}
									onChange={(options) => setSelectedRoles(options)}
									options={roles?.map(roles => ({
										value: roles.id,
										text: roles.name,
									}))}
								/>
							</div>
						</React.Fragment>
						<div className="modal-buttons-container">
							{showLoader ? (
								<Loader style={{ marginTop: '0px' }} />
							) : (
								<Button onClick={() => { sendInvite() }} label="Enviar"></Button>
							)}
						</div>
					</div>
				</Modal>
			)}
		</>
	);
}

export default Convidar;